// import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

// interface CompanyDetailsState {
//   companyName: string
//   tradeName: string
//   companyRegistrationNumber: string
//   taxIdentificationNumber: string
//   countryOfRegistration: string
//   businessRegistrationDate: string
//   taxIssuingCountry: string
//   companyType: string
//   website: string
//   businessProduct: string
//   productType: string
//   businessProgram: string
//   purposeOfUsingQwid: string
//   totalEmployees: string
//   businessScale: string
//   monthlyEstimateVolume: string
//   annualTurnover: string
//   industrySector: string
//   paymentFlowDescription: string
//   businessActivityDescription: string
//   countryOfOperation: string[]
//   businessHouseNumber: string
//   businessAddress: string
//   businessState: string
//   businessCity: string
//   businessZipcode: string
//   businessMobileCode: string
//   businessMobile: string
//   otherBusinessLicenceNumberPresent: boolean
//   otherBusinessLicenceNumber: string
//   additionalInfo: string
// }

// const initialState: CompanyDetailsState = {
//   companyName: "",
//   tradeName: "",
//   companyRegistrationNumber: "",
//   taxIdentificationNumber: "",
//   countryOfRegistration: "",
//   businessRegistrationDate: "",
//   taxIssuingCountry: "",
//   companyType: "",
//   website: "",
//   businessProduct: "",
//   productType: "",
//   businessProgram: "",
//   purposeOfUsingQwid: "",
//   totalEmployees: "",
//   businessScale: "",
//   monthlyEstimateVolume: "",
//   annualTurnover: "",
//   industrySector: "",
//   paymentFlowDescription: "",
//   businessActivityDescription: "",
//   countryOfOperation: [],
//   businessHouseNumber: "",
//   businessAddress: "",
//   businessState: "",
//   businessCity: "",
//   businessZipcode: "",
//   businessMobileCode: "",
//   businessMobile: "",
//   otherBusinessLicenceNumberPresent: false,
//   otherBusinessLicenceNumber: "",
//   additionalInfo: "",
// }

// const companyDetailsSlice = createSlice({
//   name: "companyDetails",
//   initialState,
//   reducers: {
//     setCompanyName: (state, action: PayloadAction<string>) => {
//       state.companyName = action.payload
//     },
//     setTradeName: (state, action: PayloadAction<string>) => {
//       state.tradeName = action.payload
//     },
//     setCompanyRegistrationNumber: (state, action: PayloadAction<string>) => {
//       state.companyRegistrationNumber = action.payload
//     },
//     setTaxIdentificationNumber: (state, action: PayloadAction<string>) => {
//       state.taxIdentificationNumber = action.payload
//     },
//     setCountryOfRegistration: (state, action: PayloadAction<string>) => {
//       state.countryOfRegistration = action.payload
//     },
//     setBusinessRegistrationDate: (state, action: PayloadAction<string>) => {
//       state.businessRegistrationDate = action.payload
//     },
//     setTaxIssuingCountry: (state, action: PayloadAction<string>) => {
//       state.taxIssuingCountry = action.payload
//     },
//     setCompanyType: (state, action: PayloadAction<string>) => {
//       state.companyType = action.payload
//     },
//     setWebsite: (state, action: PayloadAction<string>) => {
//       state.website = action.payload
//     },
//     setBusinessProduct: (state, action: PayloadAction<string>) => {
//       state.businessProduct = action.payload
//     },
//     setProductType: (state, action: PayloadAction<string>) => {
//       state.productType = action.payload
//     },
//     setBusinessProgram: (state, action: PayloadAction<string>) => {
//       state.businessProgram = action.payload
//     },
//     setPurposeOfUsingQwid: (state, action: PayloadAction<string>) => {
//       state.purposeOfUsingQwid = action.payload
//     },
//     setTotalEmployees: (state, action: PayloadAction<string>) => {
//       state.totalEmployees = action.payload
//     },
//     setBusinessScale: (state, action: PayloadAction<string>) => {
//       state.businessScale = action.payload
//     },
//     setMonthlyEstimateVolume: (state, action: PayloadAction<string>) => {
//       state.monthlyEstimateVolume = action.payload
//     },
//     setAnnualTurnover: (state, action: PayloadAction<string>) => {
//       state.annualTurnover = action.payload
//     },
//     setIndustrySector: (state, action: PayloadAction<string>) => {
//       state.industrySector = action.payload
//     },
//     setPaymentFlowDescription: (state, action: PayloadAction<string>) => {
//       state.paymentFlowDescription = action.payload
//     },
//     setBusinessActivityDescription: (state, action: PayloadAction<string>) => {
//       state.businessActivityDescription = action.payload
//     },
//     setCountryOfOperation: (state, action: PayloadAction<string[]>) => {
//       state.countryOfOperation = action.payload
//     },
//     setBusinessHouseNumber: (state, action: PayloadAction<string>) => {
//       state.businessHouseNumber = action.payload
//     },
//     setBusinessAddress: (state, action: PayloadAction<string>) => {
//       state.businessAddress = action.payload
//     },
//     setBusinessState: (state, action: PayloadAction<string>) => {
//       state.businessState = action.payload
//     },
//     setBusinessCity: (state, action: PayloadAction<string>) => {
//       state.businessCity = action.payload
//     },
//     setBusinessZipcode: (state, action: PayloadAction<string>) => {
//       state.businessZipcode = action.payload
//     },
//     setBusinessMobileCode: (state, action: PayloadAction<string>) => {
//       state.businessMobileCode = action.payload
//     },
//     setBusinessMobile: (state, action: PayloadAction<string>) => {
//       state.businessMobile = action.payload
//     },
//     setOtherBusinessLicenceNumberPresent: (state, action: PayloadAction<boolean>) => {
//       state.otherBusinessLicenceNumberPresent = action.payload
//     },
//     setOtherBusinessLicenceNumber: (state, action: PayloadAction<string>) => {
//       state.otherBusinessLicenceNumber = action.payload
//     },
//     setAdditionalInfo: (state, action: PayloadAction<string>) => {
//       state.additionalInfo = action.payload
//     },
//     resetCompanyDetails: () => initialState,
//   },
// })

// export const {
//   setCompanyName,
//   setTradeName,
//   setCompanyRegistrationNumber,
//   setTaxIdentificationNumber,
//   setCountryOfRegistration,
//   setBusinessRegistrationDate,
//   setTaxIssuingCountry,
//   setCompanyType,
//   setWebsite,
//   setBusinessProduct,
//   setProductType,
//   setBusinessProgram,
//   setPurposeOfUsingQwid,
//   setTotalEmployees,
//   setBusinessScale,
//   setMonthlyEstimateVolume,
//   setAnnualTurnover,
//   setIndustrySector,
//   setPaymentFlowDescription,
//   setBusinessActivityDescription,
//   setCountryOfOperation,
//   setBusinessHouseNumber,
//   setBusinessAddress,
//   setBusinessState,
//   setBusinessCity,
//   setBusinessZipcode,
//   setBusinessMobileCode,
//   setBusinessMobile,
//   setOtherBusinessLicenceNumberPresent,
//   setOtherBusinessLicenceNumber,
//   setAdditionalInfo,
//   resetCompanyDetails,
// } = companyDetailsSlice.actions

// export default companyDetailsSlice.reducer
import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface CompanyDetailsState {
  companyName: string
  tradeName: string
  companyRegistrationNumber: string
  taxIdentificationNumber: string
  countryOfRegistration: string
  businessRegistrationDate: string
  taxIssuingCountry: string
  companyType: string
  website: string
  businessProduct: string
  productType: string
  businessProgram: string
  purposeOfUsingQwid: string
  totalEmployees: string
  businessScale: string
  monthlyEstimateVolume: string
  annualTurnover: string
  industrySector: string
  paymentFlowDescription: string
  businessActivityDescription: string
  countryOfOperation: string[]
  businessHouseNumber: string
  businessAddress: string
  businessState: string
  businessCity: string
  businessZipcode: string
  businessMobileCode: string
  businessMobile: string
  otherBusinessLicenceNumberPresent: boolean
  otherBusinessLicenceNumber: string
  additionalInfo: string
}

const initialState: CompanyDetailsState = {
  companyName: "",
  tradeName: "",
  companyRegistrationNumber: "",
  taxIdentificationNumber: "",
  countryOfRegistration: "",
  businessRegistrationDate: "",
  taxIssuingCountry: "",
  companyType: "",
  website: "",
  businessProduct: "",
  productType: "",
  businessProgram: "",
  purposeOfUsingQwid: "",
  totalEmployees: "",
  businessScale: "",
  monthlyEstimateVolume: "",
  annualTurnover: "",
  industrySector: "",
  paymentFlowDescription: "",
  businessActivityDescription: "",
  countryOfOperation: [],
  businessHouseNumber: "",
  businessAddress: "",
  businessState: "",
  businessCity: "",
  businessZipcode: "",
  businessMobileCode: "",
  businessMobile: "",
  otherBusinessLicenceNumberPresent: false,
  otherBusinessLicenceNumber: "",
  additionalInfo: "",
}

const companyDetailsSlice = createSlice({
  name: "companyDetails",
  initialState,
  reducers: {
    setCompanyName: (state, action: PayloadAction<string>) => {
      state.companyName = action.payload
    },
    setTradeName: (state, action: PayloadAction<string>) => {
      state.tradeName = action.payload
    },
    setCompanyRegistrationNumber: (state, action: PayloadAction<string>) => {
      state.companyRegistrationNumber = action.payload
    },
    setTaxIdentificationNumber: (state, action: PayloadAction<string>) => {
      state.taxIdentificationNumber = action.payload
    },
    setCountryOfRegistration: (state, action: PayloadAction<string>) => {
      state.countryOfRegistration = action.payload
    },
    setBusinessRegistrationDate: (state, action: PayloadAction<string>) => {
      state.businessRegistrationDate = action.payload
    },
    setTaxIssuingCountry: (state, action: PayloadAction<string>) => {
      state.taxIssuingCountry = action.payload
    },
    setCompanyType: (state, action: PayloadAction<string>) => {
      state.companyType = action.payload
    },
    setWebsite: (state, action: PayloadAction<string>) => {
      state.website = action.payload
    },
    setBusinessProduct: (state, action: PayloadAction<string>) => {
      state.businessProduct = action.payload
    },
    setProductType: (state, action: PayloadAction<string>) => {
      state.productType = action.payload
    },
    setBusinessProgram: (state, action: PayloadAction<string>) => {
      state.businessProgram = action.payload
    },
    setPurposeOfUsingQwid: (state, action: PayloadAction<string>) => {
      state.purposeOfUsingQwid = action.payload
    },
    setTotalEmployees: (state, action: PayloadAction<string>) => {
      state.totalEmployees = action.payload
    },
    setBusinessScale: (state, action: PayloadAction<string>) => {
      state.businessScale = action.payload
    },
    setMonthlyEstimateVolume: (state, action: PayloadAction<string>) => {
      state.monthlyEstimateVolume = action.payload
    },
    setAnnualTurnover: (state, action: PayloadAction<string>) => {
      state.annualTurnover = action.payload
    },
    setIndustrySector: (state, action: PayloadAction<string>) => {
      state.industrySector = action.payload
    },
    setPaymentFlowDescription: (state, action: PayloadAction<string>) => {
      state.paymentFlowDescription = action.payload
    },
    setBusinessActivityDescription: (state, action: PayloadAction<string>) => {
      state.businessActivityDescription = action.payload
    },
    setCountryOfOperation: (state, action: PayloadAction<string[]>) => {
      state.countryOfOperation = action.payload
    },
    setBusinessHouseNumber: (state, action: PayloadAction<string>) => {
      state.businessHouseNumber = action.payload
    },
    setBusinessAddress: (state, action: PayloadAction<string>) => {
      state.businessAddress = action.payload
    },
    setBusinessState: (state, action: PayloadAction<string>) => {
      state.businessState = action.payload
    },
    setBusinessCity: (state, action: PayloadAction<string>) => {
      state.businessCity = action.payload
    },
    setBusinessZipcode: (state, action: PayloadAction<string>) => {
      state.businessZipcode = action.payload
    },
    setBusinessMobileCode: (state, action: PayloadAction<string>) => {
      state.businessMobileCode = action.payload
    },
    setBusinessMobile: (state, action: PayloadAction<string>) => {
      state.businessMobile = action.payload
    },
    setOtherBusinessLicenceNumberPresent: (state, action: PayloadAction<boolean>) => {
      state.otherBusinessLicenceNumberPresent = action.payload
    },
    setOtherBusinessLicenceNumber: (state, action: PayloadAction<string>) => {
      state.otherBusinessLicenceNumber = action.payload
    },
    setAdditionalInfo: (state, action: PayloadAction<string>) => {
      state.additionalInfo = action.payload
    },
    resetCompanyDetails: () => initialState,
  },
})

export const {
  setCompanyName,
  setTradeName,
  setCompanyRegistrationNumber,
  setTaxIdentificationNumber,
  setCountryOfRegistration,
  setBusinessRegistrationDate,
  setTaxIssuingCountry,
  setCompanyType,
  setWebsite,
  setBusinessProduct,
  setProductType,
  setBusinessProgram,
  setPurposeOfUsingQwid,
  setTotalEmployees,
  setBusinessScale,
  setMonthlyEstimateVolume,
  setAnnualTurnover,
  setIndustrySector,
  setPaymentFlowDescription,
  setBusinessActivityDescription,
  setCountryOfOperation,
  setBusinessHouseNumber,
  setBusinessAddress,
  setBusinessState,
  setBusinessCity,
  setBusinessZipcode,
  setBusinessMobileCode,
  setBusinessMobile,
  setOtherBusinessLicenceNumberPresent,
  setOtherBusinessLicenceNumber,
  setAdditionalInfo,
  resetCompanyDetails,
} = companyDetailsSlice.actions

export default companyDetailsSlice.reducer
